export enum FilterType {
  all = 'all',
  unread = 'unread',
}
